import router from './router'
import store from './store/index.js'
import { getToken, removeToken, getParam } from '@/utils/auth' // get token from cookie
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration
// start progress bar
NProgress.start()


router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()
  // set page title
  document.title = getPageTitle(to.meta.title)
  store.commit('SET_ENV', getParam('_platform'))
  if (!store.state.agent.id) {
    store.commit('TOGGLE_LOADING', true)
    try {
      store.dispatch('getAgentId')
    } finally {
      store.commit('TOGGLE_LOADING', false)
    }
  }
  if (/source/g.test(location.hash)) { // 从活动页面跳转进来的需要清空token
    removeToken()
    next()
    NProgress.done()
    return
  }
  if (hasToken) {
    if (!store.state.userInfo.username) { // 没有请求数据
      try {
        store.commit('TOGGLE_LOADING', true)
        await store.dispatch('getUserInfo')
      } finally {
        store.commit('TOGGLE_LOADING', false)
      }
    }
    if (store.state.userInfo.is_agent === 1) { // 没有数据请求数据
      try {
        store.commit('TOGGLE_LOADING', true)
        store.dispatch('getAgentInfo')
      } finally {
        store.commit('TOGGLE_LOADING', false)
      }
    }
    if (['Realidcation'].includes(to.name)) {
      store.commit('TOGGLE_VERIFY', false)
    } else {
      if (store.state.userInfo.is_verify === 0) {
        store.commit('TOGGLE_VERIFY', true)
      } else {
        store.commit('TOGGLE_VERIFY', false)
      }
    }
    if (['Login'].includes(to.name)) {
      next('/home')
      NProgress.done()
      return
    }
    next()
    NProgress.done()
  } else {
    if (!['Login', 'Register', 'ChildrenReg', 'ChildrenRegH5', 'FindPassword', 'HelpCenter', 'HelpDetail', 'HelpList'].includes(to.name)) {
      next('/login')
      NProgress.done()
      return
    }
    next()
    NProgress.done()
  }
})
